import React from 'react'
import { Bar } from 'react-chartjs-2'
import { ChartQuestionOption, respondPercentage, ChartData } from 'hooks/reports'
import { livBriteTheme } from 'app/livbrite/resources/theme'

interface Props {
  options: ChartQuestionOption[]
  totalResponses: number
}

export const BarChart = ({ options, totalResponses }: Props) => {
  const data = options.reduce((obj: ChartData, option: ChartQuestionOption, i: number) => {
    if (option.parent_id < 1) {
      obj.labels.push(option.option_label)
      obj.datasets[0].data.push(option.selected_by)
      obj.datasets[0].backgroundColor.push(livBriteTheme.palette.primary.alphaDark)
    }
    return obj
  }, { labels: [], datasets: [{ label: '# of Responses', data: [], backgroundColor: [], borderColor: [], borderWidth: 0 }] })

  const configOptions = {
    scaleShowLabels: false,
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          display: true,
          callback: function (label: string, index: number, labels: string[]) {
            return index + 1
          }
        }
      },
      y: {
        grid: {
          display: false
        },
        ticks: {
          display: false
        }
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: livBriteTheme.palette.general.light,
        titleColor: livBriteTheme.palette.primary.alphaDark,
        titleFont: { weight: 'normal', size: 14 },
        bodyFont: { weight: 'bold', size: 14 },
        footerColor: livBriteTheme.palette.primary.alphaDark,
        bodyColor: livBriteTheme.palette.primary.alphaDark,
        displayColors: false,
        callbacks: {
          label: function (context: any) {
            const value = context.parsed.y
            const percentage = `${respondPercentage(value, totalResponses)}%`
            const label = `${percentage}, ${value} ${value < 2 ? 'Response' : 'Responses'}`

            return label
          }
        }
      }
    }
  }

  return (
    <>
      <Bar type='bar' data={data} options={configOptions} />
    </>
  )
}
